// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__569d5","logo":"Navigation_logo__b3fEl","logo_img":"Navigation_logo_img__hLwtZ","link":"Navigation_link__Wc6AW","text":"Navigation_text__xSU6D"};